import React, { cloneElement, Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';

import 'animate.css/animate.min.css';
import './BuyConfirmationContainer.scss';

import { moduleActions } from '../../../redux/modules';
import {
  getPurchasingFundsIncludesNew,
  hasAppFundsOnly,
  hasRasFundsOnly,
} from '../../../redux/modules/shoppingCart/shoppingCart.selectors';
import { getHasMutualFundPaperlessConfirmations } from '../../../redux/modules/user/Paperless/paperless.selectors';
import {
  analyticsDataLayer,
  dispatchPageLoad,
} from '../../../redux/utils/analytics-helper';
import {
  isCustomerWebViewEnabled,
  isSalesforceRep,
} from '../../../redux/modules/authentication/authentication.module.selectors';

export class BuyConfirmationContainer extends Component {
  render() {
    const { children, ...passthroughProps } = this.props;
    return (
      <div className="buy-confirm-container">
        {/* Nested View */}
        <div>
          {React.Children.map(children, (child) =>
            cloneElement(child, {
              ...passthroughProps,
              analyticsDataLayer,
              dispatchPageLoad,
            })
          )}
          <div className="buy-confirm-container-clear" />
        </div>
      </div>
    );
  }
}

/**
@param state {Object}

 The idea is to create a wrapper that will logically differentiate between buy and sell
 */

const mapStateToProps = (state) => {
  const {
    executePurchase,
    paperlessSetting,
    personalInformation,
    routing,
    shoppingCart,
    user,
    userProductTypes,
    userRegistrationTypeInfo,
  } = state;
  return {
    isSalesforceRep: isSalesforceRep(state),
    customerWebViewEnabled: isCustomerWebViewEnabled(state),
    appFundsOnly: hasAppFundsOnly(state),
    rasFundsOnly: hasRasFundsOnly(state),
    confirmationNumber: executePurchase.confirmationNumber,
    executePurchase,
    includesNewFund: getPurchasingFundsIncludesNew(state),
    hasMutualFundPaperlessConfirms:
      getHasMutualFundPaperlessConfirmations(state),
    paperlessSetting,
    personalInformation,
    routing,
    shoppingCart,
    tradeDate: executePurchase.tradeDate,
    transactions: executePurchase.transactions,
    user,
    userProductTypes,
    userRegistrationTypeInfo,
  };
};

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(moduleActions, dispatch),
  dispatch,
});

export default compose(connect(mapStateToProps, mapDispatchToProps))(
  BuyConfirmationContainer
);
